import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'
import { v4 as uuidv4 } from 'uuid'

import ClipboardTextField from '@/components/ClipboardTextField.vue'
import { tripQueryKeys, useSelectedTrip } from '@/composables/trip'
import { useAutosave } from '@/composables/autosave'
import { tripModule, eventModule } from '@/store'
import AWSManager from '@/utils/aws-manager'
import { supportedPhotoFileTypes, TripRelation } from '@/utils/enums'
import { thumbnailImage } from '@/utils/utility-manager'
import { useQueryClient } from '@/composables/vue-query'


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsHeader',
  setup(__props) {

const queryClient = useQueryClient()

const trip = useSelectedTrip()

const tripTheme = computed(() => {
  return trip.value.theme.startsWith('home')
    ? require(`~/assets/themes/${trip.value.theme}.png`)
    : thumbnailImage(trip.value.theme, 1024)
})

// Trip Name ----------------------
const tripName = ref(trip.value.name)
const initialTripName = ref(trip.value.name)

async function saveName() {
  if (
    tripName.value.trim().length === 0 ||
    tripName.value === initialTripName.value
  ) {
    return
  }

  await tripModule.updateTrip({ name: tripName.value })
  initialTripName.value = tripName.value

  tripModule.postSocketTrigger({ type: TripRelation.RENAMED_TRIP })

  queryClient.invalidateQueries({
    queryKey: tripQueryKeys.lists(),
  })
}

function discardNameChanges() {
  stopAutosave()
  tripName.value = initialTripName.value
}

const { startAutosave, stopAutosave } = useAutosave({
  saveChangesCallback: saveName,
})

watch(tripName, (newTripName) => {
  if (newTripName.trim().length > 0 && newTripName !== initialTripName.value) {
    startAutosave()
  } else {
    stopAutosave()
  }
})

// Trip Image ----------------------
const fileUploaderSettingsRef = ref<HTMLInputElement | null>(null)

function toggleThemeInput() {
  fileUploaderSettingsRef.value?.click()
}

async function onFileChanged(e: Event) {
  const file = (e.target! as any).files[0]
  if (file.size > 5000000) {
    eventModule.newError('error.theme.size')
    return
  }

  if (file !== null) {
    eventModule.newInfo(`info.photo.upload`)
    const fileName = `${uuidv4()}.jpg`
    await AWSManager.uploadFile(
      `trips/${trip.value.id}/cover_photo/${fileName}`,
      file,
      () => tripModule.updateTrip({ theme: fileName }),
    )
  }
}

return { __sfc: true,queryClient, trip, tripTheme, tripName, initialTripName, saveName, discardNameChanges, startAutosave, stopAutosave, fileUploaderSettingsRef, toggleThemeInput, onFileChanged, ClipboardTextField, supportedPhotoFileTypes }
}

})